import { useEffect, useState } from "react";
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
const useSignalr = (methodName: string) => {

    const [connection, setConnection] = useState<HubConnection>();

    useEffect(() => {
        const baseUrl = process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL.toString() : '';
        const newConnection = new HubConnectionBuilder()
            .withUrl(baseUrl + methodName)
            .withAutomaticReconnect()
            .build();

        setConnection(newConnection);
        // on destroy close the connexion :D
        return () => {
            newConnection.stop().then((d) => {
                setConnection(newConnection);
            });

        };
    }, []);

    return { connection };
}

export default useSignalr;